<template>
  <div>
    <b-container class="text-left">
      <h1 class="text-left mt-2 mb-4">Kedvencek</h1>
      <div class="favourites-filter-tabs">
        <b-tabs content-class="mt-3">
          <b-tab title="Lehetőségek" active>
            <Opportunities />
          </b-tab>
          <b-tab title="Forráslisták">
            <FundMapList />
          </b-tab>
        </b-tabs>
      </div>
    </b-container>
    <SmeClassificationInformation currentPage="Favourites" />
  </div>
</template>

<script>
import Opportunities from './components/Opportunities.vue'
import FundMapList from './components/FundMapList.vue'
import SmeClassificationInformation from '@/components/SmeClassificationInformation.vue'

export default {
  name: 'Favourites',
  components: {
    Opportunities,
    FundMapList,
    SmeClassificationInformation
  }
}
</script>

<style scoped>
.favourites-filter-tabs {
  .nav-tabs {
    border-bottom: unset;
  }
  .nav-link {
    border: unset;
    color: #2d3436;
    border-bottom: 2px solid #dfe2ea;
    margin-bottom: 1px;
    &:hover {
      color: #2d3436;
    }
  }
  .nav-link.active {
    border-bottom: 2px solid #00903c;
  }
}
</style>
